import React, { useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { formatDateInputForDateTimeLocal } from '../../utils/attendanceDateTime';

export default function EditShiftDialog({ open, onOpenChange, shift, onSubmit, submitting }) {
  const [formData, setFormData] = useState({
    newClockInAt: '',
    newClockOutAt: '',
    notes: '',
    reason: '',
  });

  useEffect(() => {
    if (!shift) return;
    setFormData({
      newClockInAt: formatDateInputForDateTimeLocal(shift.clock_in_at),
      newClockOutAt: formatDateInputForDateTimeLocal(shift.clock_out_at),
      notes: shift.notes || '',
      reason: '',
    });
  }, [shift]);

  const handleSave = async (event) => {
    event.preventDefault();
    if (!shift) return;

    await onSubmit({
      timeEntryId: shift.id || shift.time_entry_id,
      ...formData,
      newClockOutAt: formData.newClockOutAt || null,
      notes: formData.notes || null,
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#1E1E1E] border-[#3F3F46] text-white max-w-xl">
        <DialogHeader>
          <DialogTitle className="font-heading uppercase">Edit Shift</DialogTitle>
          <DialogDescription className="text-[#A1A1AA]">
            Update clock times and provide a required reason for audit history.
          </DialogDescription>
        </DialogHeader>

        {!shift ? null : (
          <form onSubmit={handleSave} className="space-y-4">
            <div className="rounded-md border border-[#3F3F46] bg-[#121212] p-3 text-sm text-[#E4E4E7]">
              <p><span className="text-[#A1A1AA]">Staff:</span> {shift.staff_name || '-'}</p>
              <p><span className="text-[#A1A1AA]">Venue:</span> {shift.venue_name || '-'}</p>
              <p><span className="text-[#A1A1AA]">Date:</span> {shift.shift_date || '-'}</p>
            </div>

            <div className="grid gap-4 md:grid-cols-2">
              <div>
                <Label className="mb-2 block">Clock In *</Label>
                <Input
                  type="datetime-local"
                  value={formData.newClockInAt}
                  onChange={(e) => setFormData((prev) => ({ ...prev, newClockInAt: e.target.value }))}
                  className="input-rtb"
                  required
                />
              </div>
              <div>
                <Label className="mb-2 block">Clock Out</Label>
                <Input
                  type="datetime-local"
                  value={formData.newClockOutAt}
                  onChange={(e) => setFormData((prev) => ({ ...prev, newClockOutAt: e.target.value }))}
                  className="input-rtb"
                />
              </div>
            </div>

            <div>
              <Label className="mb-2 block">Notes</Label>
              <Textarea
                value={formData.notes}
                onChange={(e) => setFormData((prev) => ({ ...prev, notes: e.target.value }))}
                className="input-rtb min-h-[90px]"
              />
            </div>

            <div>
              <Label className="mb-2 block">Reason For Edit *</Label>
              <Textarea
                value={formData.reason}
                onChange={(e) => setFormData((prev) => ({ ...prev, reason: e.target.value }))}
                className="input-rtb min-h-[90px]"
                required
              />
            </div>

            <DialogFooter>
              <Button type="button" variant="secondary" onClick={() => onOpenChange(false)}>
                Cancel
              </Button>
              <Button type="submit" disabled={submitting || !formData.reason.trim()}>
                {submitting ? 'Saving...' : 'Save Shift Changes'}
              </Button>
            </DialogFooter>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
